import { cx } from './cx.js';

/**
 * A marca do produto — a mesma do site (repo `condos-land`).
 *
 * Sao duas pecas com papeis diferentes, e trocar uma pela outra e o erro
 * comum:
 *
 * - `CondosMark` e o predio sozinho. E um SVG inline em `currentColor` de
 *   proposito: ele aparece dentro de botao, de avatar e sobre o accent, e uma
 *   imagem de cor fixa ficaria invisivel em metade desses lugares.
 * - `CondosWordmark` e o logotipo "CONDOS" completo, com o predio no lugar do
 *   O. Esse e raster (o desenho das letras nao e uma fonte que o app tenha),
 *   entao vive em `public/brand` e nao no bundle.
 *
 * O wordmark tem o texto em branco: ele so funciona sobre fundo escuro — que
 * e o unico que o app tem (`color-scheme: dark`).
 */

/**
 * Proporcao do PNG. O arquivo original do site tem 3859px de largura e 142 KB;
 * aqui ele nunca passa de uns 100px na tela, entao entrou reduzido para 682px
 * (25 KB) — a portaria abre o app no 4G do celular.
 */
const WORDMARK_WIDTH = 682;
const WORDMARK_HEIGHT = 120;

export function CondosMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 92 96"
      className={cx('fill-current', className)}
      aria-hidden
      focusable="false"
    >
      <path d="M25 5 43 1v19l-18 4V5Z" />
      <path d="m50 1 18 5v19l-18-5V1Z" />

      <path d="M0 33 18 29v19L0 52V33Z" />
      <path d="m25 28 18-4v21l-18 4V28Z" />
      <path d="m50 24 18 5v21l-18-5V24Z" />
      <path d="m75 31 17 5v19l-17-5V31Z" />

      <path d="M0 57 18 53v18L0 75V57Z" />
      <path d="m25 53 18-4v20l-18 4V53Z" />
      <path d="m50 49 18 5v20l-18-5V49Z" />
      <path d="m75 54 17 5v18l-17-5V54Z" />

      <path d="M0 80 18 76v20H0V80Z" />
      <path d="m25 77 18-4v23H25V77Z" />
      <path d="m50 73 18 5v18H50V73Z" />
      <path d="m75 77 17 5v14H75V77Z" />
    </svg>
  );
}

/**
 * O logotipo completo. `height` em rem/px define o tamanho; a largura sai da
 * proporcao para o navegador nao precisar baixar a imagem antes de reservar o
 * espaco — sem isso o menu inteiro pula quando o PNG chega.
 */
export function CondosWordmark({
  height = '1.15rem',
  className,
}: {
  height?: string;
  className?: string;
}) {
  return (
    <img
      src="/brand/condos-logo.png"
      alt="Azko Condos"
      className={cx('block w-auto max-w-full', className)}
      style={{ height, aspectRatio: `${WORDMARK_WIDTH} / ${WORDMARK_HEIGHT}` }}
      width={WORDMARK_WIDTH}
      height={WORDMARK_HEIGHT}
      decoding="async"
    />
  );
}
